import {makeAutoObservable} from "mobx";
import Store from "./Store";

export const JwtToken: string = "yna-jwt-token";
export const RefreshToken: string = "yna-refresh-token";

type UserData = {
  fullName: string;
  linkId: string;
  id: string;
  isCoach: boolean;
  sex: string;
  birthDate: string;
  weight: number | null;
  city: string;
  about: string;
  services: string[];
  activeSubscriptions: string[];
};

type VerificationData = {
  token: string;
  verified: boolean;
};

class AuthStore {
  isInternalAuthenticated: boolean = false;
  identifier?: string = "";
  loginProvider: string = "";
  currentUser?: UserData;

  constructor(private store: Store) {
    makeAutoObservable(this);
    this.isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  }

  saveAuthToken(authKey: string, refreshToken: string) {
    localStorage.setItem(JwtToken, authKey);
    localStorage.setItem(RefreshToken, refreshToken);
    localStorage.setItem("isAuthenticated", true.toString());
    this.isAuthenticated = true;
  }

  saveCurrentUser(userData?: UserData) {
    this.currentUser = userData;
  }

  addService(service: string) {
    if (!this.currentUser) return;
    
    if (!this.currentUser.services.includes(service)) {
      this.currentUser = {
        ...this.currentUser,
        services: [...this.currentUser.services, service],
      };
    }
  }

  removeService(service: string) {
    if (!this.currentUser) return;

    this.currentUser = {
      ...this.currentUser,
      services: this.currentUser.services.filter(s => s !== service),
    };
  }

  logout(): void {
    localStorage.removeItem(JwtToken);
    localStorage.removeItem(RefreshToken);
    localStorage.removeItem("isAuthenticated");
    this.isAuthenticated = false;
  }

  async getAuthToken() {
    return localStorage.getItem(JwtToken) as string;
  }

  get isAuthenticated() {
    return this.isInternalAuthenticated;
    // const isAuth = localStorage.getItem("isAuthenticated");
    // return isAuth === "true";
  }
  set isAuthenticated(isAuth: boolean) {
    this.isInternalAuthenticated = isAuth;
  }

  getIdentifier(): string {
    return this.identifier ?? "";
  }

  setIdentifier(identity: string | undefined) {
    this.identifier = identity;
  }

  getLoginProvider(): string {
    return this.loginProvider ?? "";
  }

  setLoginProvider(loginProvider: string | undefined) {
    this.loginProvider = loginProvider ?? "";
  }
  
  setVerificationToken(value: string | "") {
    const data = {
      token: value,
      verified: false
    }
    sessionStorage.setItem("yna-v-token", JSON.stringify(data));
  }
  
  getVerificationToken() : VerificationData | null {
    const data = sessionStorage.getItem("yna-v-token");
    return data ? JSON.parse(data) : null;
  }
  
  setVerified(value: boolean) {
    const data = sessionStorage.getItem("yna-v-token");
    if (!data) return;
    
    const tokenData = JSON.parse(data);
    tokenData.verified = value;

    sessionStorage.setItem("yna-v-token", JSON.stringify(tokenData));
  }
  
  clearVerificationToken(): void {
    sessionStorage.removeItem("yna-v-token");
  }
}

export default AuthStore;
